import React, { Component } from 'react';
import Moment from 'moment';
import ReactPlayer from 'react-player/file';
import VideoThumbnail from '../gallery/VideoThumbnail';
import {
  getCurrentExperience,
  visibilityAllowsExperience,
} from '../../utils/visibility';

function getExperience() {
  return getCurrentExperience();
}

function isVisibleByExperience(item) {
  const experience = getExperience();
  return visibilityAllowsExperience(item && item.visibilityValue, experience);
}

function getVisibleVideos(props) {
  const groups =
    props?.gallery?.props?.homePageQuery?.galleryPages?.[0]?.galleryGroups || [];

  let allItems = [];

  groups.forEach((group) => {
    if (group?.galleryItems && group.galleryItems.length > 0) {
      group.galleryItems.forEach((item) => {
        const url = item?.file?.url || '';
        if (url.includes('videos') && isVisibleByExperience(item)) {
          allItems.push(item);
        }
      });
    }
  });

  allItems.sort((a, b) => {
    const dateA = new Date(a.releaseDate);
    const dateB = new Date(b.releaseDate);
    return dateB - dateA;
  });

  return allItems;
}

class Gallery extends Component {
  render() {
    const allItems = getVisibleVideos(this.props);

    // ✅ Hide entire section if no videos
    if (!allItems || allItems.length === 0) {
      return null;
    }

    return (
      <section className="section highlight-section ">
        <header className="section-header row">
          <div className="col">
            <h2 className="section-title section-title-left">Video Series</h2>
            <a href="/video-series" className="view-all">
              View all Series
            </a>
          </div>
        </header>

        <div className="section-content row cubs-news">
          {allItems.slice(0, 3).map((link, index) => {
            const videoName = link?.name || '';
            const videoUrl = link?.file?.url || '';

            return (
              <div key={index} id={videoName} className="col md-4 news flex-item">
                <div className="news-img-container">
                  <div className="player-wrapper">
                    <ReactPlayer
                      config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                      id={videoName}
                      onStart={() =>
                        window.dataLayer &&
                        window.dataLayer.push({
                          event: 'gallery_video_start',
                          video_name: videoName,
                        })
                      }
                      onEnded={() =>
                        window.dataLayer &&
                        window.dataLayer.push({
                          event: 'gallery_video_end',
                          video_name: videoName,
                        })
                      }
                      className="react-player"
                      controls
                      light={
                        <VideoThumbnail
                          videoUrl={videoUrl}
                          thumbnailHandler={(thumbnail) => thumbnail}
                          snapshotAtTime={link.snapshotTime}
                        />
                      }
                      muted
                      width="100%"
                      height="100%"
                      url={videoUrl}
                    />
                  </div>
                </div>

                <h3>
                  <b>{videoName}</b>
                </h3>

                <p>
                  {link?.releaseDate
                    ? Moment.utc(link.releaseDate).format('MM/DD/YYYY')
                    : ''}
                </p>

                <p>{link?.description || ''}</p>
              </div>
            );
          })}
        </div>
      </section>
    );
  }
}

export default Gallery;
